import { useRequest } from '@features/request/useRequest';

import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { removeLimitedCostTypeGql } from '../CatalogLimitedTypeQueries';

type TProps = {
    onSuccess: () => void;
};

export const useRemoveLimitedType = ({ onSuccess }: TProps) => {
    const dispatch = useDispatch();

    const [, , , request] = useRequest({
        requestId: 'removeLimitedCostType',
        query: removeLimitedCostTypeGql,
        withEffect: false,
        dependenciesUpdater: onSuccess,
    });

    const handleRemove = useCallback(
        (id: number) => {
            dispatch(request({ id }));
        },
        [dispatch, request],
    );

    return useMemo(() => handleRemove, [handleRemove]);
};
